import { SearchHitSearchProductEntity } from '@generated-client/backend';
import { BACKEND_API } from '@trwl/backend.api';
import { createEffect, createStore } from 'effector';
import { debounce } from 'patronum/debounce';

import { SEARCH } from '../search';

const $productsSuggestions = createStore<SearchHitSearchProductEntity[]>([]);
const $productsLoading = createStore<boolean>(false);

export const PRODUCT_SUGGESTION = {
  $productsSuggestions,
  $productsLoading,
};

let currentAbortController: AbortController | null = null;

export const findProductsSuggestionFx = createEffect<
  string | undefined,
  SearchHitSearchProductEntity[],
  Error
>(async (keyword) => {
  if (currentAbortController) {
    currentAbortController.abort();
  }
  currentAbortController = new AbortController();
  const { signal } = currentAbortController;
  if (!keyword) return [];
  return BACKEND_API.ElasticApi.findProducts(
    {
      keyword,
      size: 5,
      page: 0,
    },
    { signal },
  ).then(({ data }) => data.content ?? []);
});

$productsSuggestions.on(
  findProductsSuggestionFx.doneData,
  (state, products) => products,
);

$productsLoading.on(
  findProductsSuggestionFx.pending,
  (_, isPending) => isPending,
);

const setSearchDebounced = debounce(SEARCH.setSearch, 300);
setSearchDebounced.watch(findProductsSuggestionFx);
